import {Component, Input, OnInit, ViewChild} from "@angular/core";
import { Router } from "@angular/router";
import { LoginUrl } from "src/app/constants/url/login.url";
import { WeatherAPIURL } from "src/app/constants/url/weatherAPI.url";
import { ResponseDto } from "src/app/dto/common/response.dto";
import { FlightConfigurationDto } from "src/app/dto/flightConfiguration/flightConfiguration.dto";
import { UnitDto } from "src/app/dto/unit/unit.dto";
import { DustDto } from "src/app/dto/weatherTable/dust/dust.dto";
import { KpListDto } from "src/app/dto/weatherTable/kp/kpList.dto";
import { WeatherListDto } from "src/app/dto/weatherTable/weather/weatherList.dto";
import { AccountService } from "src/app/service/account/account.service";
import { HttpService } from "src/app/service/http/http.service";
import { LocalizationService } from "src/app/service/localization/localization.service";
import { PopupData } from "src/app/service/popup/popup.data";
import { PopupService } from "src/app/service/popup/popup.service";
import { ConfigurationComponent } from "../configuration/configuration.component";
import { SummaryComponent } from "../summary/summary.component";
import { WeatherTableComponent } from "../weatherTable/weatherTable.component";
import {KeycloakService} from "../../service/keycloak/keycloak.service";
import {CookieService} from "../../service/cookie/cookie.service";
import {AccountDto} from "../../dto/login/account.dto";
import {JoinUrl} from "../../constants/url/join.url";
import {GRAPHQL, PORTAL_LOGIN} from "../../constants/environment.constants";
import {GET_USER_BY_EMAIL} from "../../constants/query/user.query";
import {interval} from "rxjs";

@Component({
    templateUrl: '../../view/main/main.html'
})
export class MainComponent implements OnInit {
    public alertData: PopupData = new PopupData();

    public isReadyDroneSpecification: boolean = false;
    public isOverlay: boolean = false;

    @ViewChild(ConfigurationComponent) private configurationComponent!: ConfigurationComponent;
    @ViewChild(SummaryComponent) private summaryComponent!: SummaryComponent;
    @ViewChild(WeatherTableComponent) private weatherTableComponent!: WeatherTableComponent;

    constructor(
        private router: Router,
        private httpService: HttpService,
        private popupService: PopupService,
        private accountService: AccountService,
        private localizationService: LocalizationService,
        private cookieService: CookieService,
        private keycloakService: KeycloakService
    ) {
        this.refreshToken();
    }

    ngOnInit() {
        this.autoLogin();
    }

    public autoLogin(): void {
        if (this.cookieService.getCookie("token") && this.cookieService.getCookie("token").accessToken) {
            this.keycloakService.getUserEmail(this.cookieService.getCookie("token").accessToken).subscribe(
                emailResponse => {
                    this.accountService.setAccount(emailResponse)
                    const email = emailResponse.preferred_username;

                    this.httpService.get<ResponseDto<AccountDto>>(LoginUrl.account(email))
                        .subscribe(response => {
                            if (response.isSuccess) {
                                this.accountService.setAccount(response.data);
                                this.configurationComponent.getFlightConfiguration();
                            } else {
                                this.autoSignUp(email);
                            }
                        });
                }
            );
        } else {
            alert("Token is not exist");
            window.open(PORTAL_LOGIN, "_self");
        }
    }

    private autoSignUp(email: string): void {
        this.httpService.post<ResponseDto<any>>(GRAPHQL, {query: GET_USER_BY_EMAIL(email)})
            .subscribe(infoResponse => {
                const user = new AccountDto();
                user.seq = infoResponse.data.getUser.seq;
                user.email = email;
                user.name = infoResponse.data.getUser.name;

                this.httpService.post<ResponseDto<AccountDto>>(JoinUrl.join, user)
                    .subscribe(response => {
                        if (response.isSuccess) {
                            this.accountService.setAccount(user);
                            this.configurationComponent.getFlightConfiguration();
                        } else {
                            alert("Sign up Failed");
                            window.open(PORTAL_LOGIN, "_self");
                        }
                    });
            });
    }

    private refreshToken(): void {
        interval(1000 * 60 * 3).subscribe(() => {
            let token = this.cookieService.getCookie("token");

            if (token) {
                this.keycloakService.refreshToken(token.refreshToken).subscribe(
                    response => {
                        this.cookieService.setCookie("token", {
                            accessToken: response.access_token,
                            refreshToken: response.refresh_token
                        });
                    }
                );
            }
        });
    }

    ngAfterViewInit() {
        this.popupService.alert$.subscribe(popupData => {
            this.isOverlay = true;
            this.alertData = popupData;
        });
    }

    public closeAlert(): void {
        this.isOverlay = false;
        this.alertData.isVisible = false;
    }

    public getAccountName(): string {
        return this.accountService.getAccountName();
    }

    public logout(): void {
        // this.httpService.post(LoginUrl.clear, this.accountService.getAccountUUID());
        // this.accountService.clear();
        //
        // this.router.navigateByUrl("");

        const refreshToken = this.cookieService.getCookie("token").refreshToken;
        this.keycloakService.logout(refreshToken).subscribe(() => {
                this.cookieService.deleteCookie("token")
                window.open(PORTAL_LOGIN, "_self")
        });
    }

    public isKorean(): boolean {
        return this.localizationService.isKorean;
    }

    public toggleLanguage(): void {
        this.localizationService.toggleLanguage();
    }

    public toggleOverlayVisible(): void {
        this.isOverlay = !this.isOverlay;
    }

    public toggleFlightConfigurationSettingVisible(): void {
        this.configurationComponent.toggleFlightConfigurationSettingVisible();
    }

    public changeFlightConfigEvent(flightConfigurationDto: FlightConfigurationDto): void {
        this.weatherTableComponent.setFlightConfiguration(flightConfigurationDto);
        this.summaryComponent.setFlightConfiguration(flightConfigurationDto);
    }

    public changeUnitEvent(unitDto: UnitDto): void {
        this.isOverlay = false;

        this.weatherTableComponent.setUserUnit(unitDto);
        this.summaryComponent.setUserUnit(unitDto);
    }

    public changeGustEvent(isContainedGust: boolean): void {
        this.summaryComponent.setContainedGust(isContainedGust);
        this.weatherTableComponent.setContainedGust(isContainedGust);
    }

    public setAddress(address: string): void {
        this.summaryComponent.setAddress(address);
    }

    public getWeatherData(searchDto: {}): void {
        this.getWeatherListDto(searchDto);
        this.getKpList(searchDto);
        this.getCurrentSatelliteCount(searchDto);
        this.getDustInfo(searchDto);
    }

    private getWeatherListDto(searchDto: {}): void {
        this.httpService.post<ResponseDto<WeatherListDto[]>>(WeatherAPIURL.weather, searchDto)
            .subscribe(response => {
                if (response.isSuccess) {
                    this.summaryComponent.setWeatherList(response.data);
                    this.weatherTableComponent.setWeatherList(response.data);
                }
            });
    }

    private getKpList(searchDto: {}): void {
        this.httpService.post<ResponseDto<KpListDto[]>>(WeatherAPIURL.kp, searchDto)
            .subscribe(response => {
                if (response.isSuccess) {
                    this.summaryComponent.setKpList(response.data);
                    this.weatherTableComponent.setKpList(response.data);
                }
            });
    }

    private getCurrentSatelliteCount(searchDto: {}): void {
        this.httpService.post<ResponseDto<number>>(WeatherAPIURL.satellite, searchDto)
            .subscribe(response => {
                if (response.isSuccess) {
                    this.summaryComponent.setCurrentSatelliteCount(response.data);
                    this.weatherTableComponent.setCurrentSatelliteCount(response.data);
                }
            });
    }

    private getDustInfo(searchDto: {}): void {
        this.httpService.post<ResponseDto<DustDto>>(WeatherAPIURL.dust, searchDto)
            .subscribe(response => {
                if (response.isSuccess) {
                    this.summaryComponent.setDustInfo(response.data);
                }
            });
    }
}
